var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-280.4 487.6 616.4 608.3",
    enableBackground: "new -280.4 487.6 616.4 608.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.2,1044.7L143.6,861.1c-0.3-0.3-0.6-0.6-0.9-0.8c29.4-39.9,45.3-88,45.3-138.5c0-62.6-24.4-121.4-68.6-165.6 c-44.2-44.2-103-68.6-165.6-68.6s-121.4,24.4-165.6,68.6c-44.2,44.2-68.6,103-68.6,165.6s24.4,121.4,68.6,165.6 c44.2,44.2,103,68.6,165.6,68.6c54.4,0,106-18.4,147.6-52.3l183.4,183.4c5.9,5.9,13.5,8.8,21.2,8.8c7.7,0,15.4-2.9,21.2-8.8 C338.9,1075.4,338.9,1056.4,327.2,1044.7z M-46.2,916c-107.1,0-194.2-87.1-194.2-194.2s87.1-194.2,194.2-194.2 c107.1,0,194.2,87.1,194.2,194.2S60.9,916-46.2,916z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7fed7eae.svg";
export { ForwardRef as ReactComponent };